export default {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json-patch+json', 'appId': 'CSM1803' },
    Accept: 'application/json',
    body: `{}`,
}